import React, { useState, useEffect } from 'react';
import cmsApi from '../../services/cmsApi';

const AnnouncementBanner = () => {
  const [announcements, setAnnouncements] = useState([]);

  useEffect(() => {
    cmsApi.getAnnouncements()
      .then(res => {
        if (res.success && res.announcements?.length) {
          setAnnouncements(res.announcements);
        }
      })
      .catch(() => {});
  }, []);

  if (!announcements.length) return null;

  return (
    <div style={{
      background: 'linear-gradient(90deg, #5d0470 0%, #3b0764 100%)',
      borderBottom: '2px solid #fca903',
    }}>
      {announcements.map((ann) => {
        const inner = (
          <span className="ann-blink" style={{
            color: '#fca903',
            fontWeight: 700,
            fontSize: '0.92rem',
            letterSpacing: '0.04em',
            textTransform: 'uppercase',
          }}>
            {ann.text}
          </span>
        );

        return (
          <div
            key={ann.id}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '10px 16px',
              textAlign: 'center',
              gap: '10px',
            }}
          >
            {/* Blinking dot */}
            <span className="ann-dot" style={{
              display: 'inline-block',
              width: '8px',
              height: '8px',
              borderRadius: '50%',
              background: '#fca903',
              flexShrink: 0,
            }} />

            {ann.url ? (
              <a
                href={ann.url}
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: 'none', lineHeight: 1.4 }}
              >
                {inner}
              </a>
            ) : inner}

            <span className="ann-dot" style={{
              display: 'inline-block',
              width: '8px',
              height: '8px',
              borderRadius: '50%',
              background: '#fca903',
              flexShrink: 0,
            }} />
          </div>
        );
      })}

      <style>{`
        @keyframes annBlink {
          0%, 49%  { opacity: 1; }
          50%, 100% { opacity: 0; }
        }
        @keyframes annDotPulse {
          0%, 100% { transform: scale(1); opacity: 1; }
          50%       { transform: scale(1.6); opacity: 0.5; }
        }
        .ann-blink {
          animation: annBlink 1.2s step-end infinite;
        }
        .ann-dot {
          animation: annDotPulse 1.2s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
};

export default AnnouncementBanner;
